import { render, staticRenderFns } from "./FitnessplanDetailModal.vue?vue&type=template&id=b35e3c60&scoped=true&"
import script from "./FitnessplanDetailModal.vue?vue&type=script&lang=js&"
export * from "./FitnessplanDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./FitnessplanDetailModal.vue?vue&type=style&index=0&id=b35e3c60&lang=scss&scoped=true&"
import style1 from "./FitnessplanDetailModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35e3c60",
  null
  
)

export default component.exports